























import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Rank from '@/_shared/entities/rank/rank.entity';
import moment from 'moment/moment';
import throttle from 'lodash/throttle';

@Component
export default class RankBar extends Vue {
  @Prop({ type: Array })
  public ranks!: Rank[];

  @Prop({ type: Object, default: () => ({}) })
  public selectedRank!: Rank;

  getRankBarClass(rank: Rank): Record<string, boolean> {
    return {
      'rank-bar__rank--active': this.selectedRank?.id === rank.id,
    };
  }

  formatDate(achievementDate: string): string {
    if (!achievementDate) return '';
    return moment(achievementDate).format('MM/YY');
  }

  scrollActiveIntoView(): void {
    const activeElement = document.getElementsByClassName('rank-bar__rank--active')[0];
    const container = document.getElementById('rank-bar-container');
    if (!activeElement || !container) return;
    const offsetMiddle = window.outerWidth / 2.6;
    const xScroll = (activeElement as HTMLElement).offsetLeft - offsetMiddle;
    container.scroll({ top: 0, left: xScroll, behavior: 'smooth' });
  }

  selectRank(rank: Rank) {
    this.$emit('update:selected-rank', rank);
  }

  mounted() {
    window.addEventListener('resize', throttle(this.scrollActiveIntoView, 200));
    this.scrollActiveIntoView();
  }

  @Watch('selectedRank')
  handleSelectedRankChange() {
    this.$nextTick(() => {
      this.scrollActiveIntoView();
    });
  }
}
